import { i18n } from '@/i18n/i18n'
import { mapGetters } from 'vuex'
import ProfileMenuMobile from '@/agilis/mobile/ProfileMenuMobile/ProfileMenuMobile.vue'
import dumpUserActionMixin from '@/agilis/components/DataTableV2/common/dumpUserActionMixin'

export default {
  name: 'AppBarMobile',
  components: {
    ProfileMenuMobile
  },
  mixins: [dumpUserActionMixin],
  data () {
    return {
      isHomeRoute: this.$route.path === '/',
      isApplicationRoute: false,
      menuVisible: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.isHomeRoute = to.path === '/'
      this.isApplicationRoute = this.$route.path.includes('application') && !this.$route.path.includes('view')
    }
  },
  methods: {
    openSearchBar () {
      this.$store.commit('mobileDataTableStore/setIsVisibleSearch', !this.isVisibleSearch)
    },
    openListViews () {
      this.$store.commit('mobileDataTableStore/setIsVisibleViews', !this.isVisibleSavedViews)
    },
    openListTrackers () {
      this.$store.commit('mobileDataTableStore/setOpenMenu', !this.menuState)
    },
    goBack () {
      this.menuVisible = false
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapGetters({
      'configLoaded': 'configurationStore/configurationLoadingCompleted',
      'applicationName': 'contextStore/applicationName',
      'workspaceName': 'contextStore/workspaceName',
      'menuState': 'mobileDataTableStore/openMenu',
      'isVisibleSearch': 'mobileDataTableStore/isVisibleSearch',
      'isVisibleSavedViews': 'mobileDataTableStore/isVisibleSavedViews',
      'viewFilterSelected': 'mobileDataTableStore/getSavedSelectedView',
      'searchTextState': 'mobileDataTableStore/getSearchTxt',
      'userActivities': 'userActivityStore/userActivities',
      'viewsAvailable': 'mobileDataTableStore/getAvaibleViews',
      'appBarImg': 'themeStore/getAppBarImgMobile',
      'isVisibleTrackerTabsIcon': 'mobileDataTableStore/isVisibleTrackerTabsIcon',
      authorizedAppTrackerTypes: 'contextStore/trackerTypes'
    }),
    isSearchTextActive () {
      const lastUserActivity = this.userActivities(this.dumpRoute)?.search
      const searchTextState = this.searchTextState
      return lastUserActivity || searchTextState
    },
    appBarTitle () {
      let title = 'ARPA '
      if (this.configLoaded) {
        if (this.applicationName) {
          title = i18n.t(this.applicationName)
          if (this.authorizedAppTrackerTypes !== undefined) {
            this.menuVisible = true
          }
        }
      }
      return title
    },
    workspaceDescription () {
      return i18n.t(this.workspaceName)
    }
  }
}
